function truncateString(text, length) {
    if(text == null || text == '' || text.length < length) return text;
    return `${text.substring(0, 127)}...`
}

export default truncateString;
